import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { buildOAuthState } from '../../../constants/oauth'
import AuthLayout from '../common/AuthLayout'
import SignUpSegmentSelector from '../common/SignUpSegmentSelector'

// A coach-invited golfer is handed straight to the IdP to set a password, so they never see the
// segment chooser that self-registration puts in front of it and account_segment stays blank. The
// invite email points here instead: we ask the question, then forward to the IdP URL the link
// carries, with the answer in the state param. The IdP echoes state back on the redirect, so
// oauth_login records the choice along with the sign-in.
const AcceptInvitePage = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const next = searchParams.get('next')

  // `next` arrives in a URL from an email, so it cannot be trusted to be ours. Without this an
  // attacker could send a legitimate-looking Op 36 link that bounces the recipient anywhere.
  const idpUrl = () => {
    try {
      const url = new URL(next)
      const allowedOrigin = new URL(process.env.REACT_APP_OAUTH_PROVIDER_HOST).origin

      return url.origin === allowedOrigin ? url : null
    } catch {
      return null
    }
  }

  const handleSelect = (segment) => {
    const url = idpUrl()
    if (!url) { return }

    url.searchParams.set('state', buildOAuthState(segment))
    window.location.href = url.toString()
  }

  if (!idpUrl()) {
    return (
      <AuthLayout>
        <p className='text-white text-center mt-4'>{t('auth.acceptInvite.invalidLink')}</p>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout selectorMode>
      <SignUpSegmentSelector
        onIndividualClick={() => handleSelect('individual')}
        onFamilyClick={() => handleSelect('family')}
        heading={t('auth.acceptInvite.heading')}
        showCoachOption={false}
      />
    </AuthLayout>
  )
}

export default AcceptInvitePage
